/**
 * It's suggested to configure the RESTful endpoints in this file
 * so that there is only one source of truth, future update of endpoints
 * could be done from here without refactoring on multiple places throughout the app
 */

/** test */
const API_HOST = process.env.REACT_APP_API_HOST;
const PATH_IMAGES_AGENCE = process.env.REACT_APP_PATH_IMAGES_AGENCE;
const PATH_FILES_CANDIDATE = process.env.REACT_APP_PATH_FILES_CANDIDATE;
/* ******************************************** */
/** prod */
// const API_HOST = 'https://api.valjob.prod-projet.com';
// const PATH_IMAGES_AGENCE = 'https://api.valjob.prod-projet.com/Image_agences/';
// const PATH_FILES_CANDIDATE = 'https://api.valjob.prod-projet.com/candidates_documents/';
/* ******************************************** */
/* ******************************************** */
/** preprod client */
// const API_HOST = 'https://admin-preprod.valjob.digital';
// const PATH_IMAGES_AGENCE = 'https://admin-preprod.valjob.digital/Image_agences/';
// const PATH_FILES_CANDIDATE = 'https://admin-preprod.valjob.digital/candidates_documents/';
/* ******************************************** */
/** prod client */
// const API_HOST = 'https://admin.valjob.digital';
// const PATH_IMAGES_AGENCE = 'https://admin.valjob.digital/Image_agences/';
// const PATH_FILES_CANDIDATE = 'https://admin.valjob.digital/candidates_documents/';
/* ******************************************** */

const API = {
    auth: {
        register: '/candidate/register',
        checkExistMail: '/email',
        checkEmailState: '/checkjobber',
        login: '/login',
        socialLogin: '/social/login',
        loginLinkedIn: '/linkedin-email',
        forgetPassword: '/password_reset',
        resetPassword: '/password_reset/reset',
        sectors: '/activitySectors',
        professions: '/professions',
        jobtypes: '/jobtypes',
        nationalities: '/nationalities',
        locations: '/locations',
        workingpermissions: '/workingpermissions',
        listAgences: '/agenciesList',
        reactivate: '/api/reactivate/candidate/',
        registerAgency: '/client/register',
        refreshToken: '/token/refresh',
        emailVerification: '/verification/sendEmail',
        candidateAddresses: '/api/addresses',
    },
    parsingCV: {
        parsing: '/cv/parse/informations',
    },
    profile: {
        candidate: '/api/Profil/details/',
        delete: '/api/Profil/delete/',
        editCandidate: '/api/Profil/',
        uploadImage: '/api/Profil/uploadFile/',
        addingFormation: '/api/Formation/new',
        deletingFormation: '/api/Formation/',
        addingProfessionalExperience: '/api/ProfessionalExperiences/new',
        deletingProfessionalExperience: '/api/ProfessionalExperiences/',
        deletingFile: '/api/File/',
        deletingFiles: '/api/File/delete',
        multiposting: '/api/candidate/multiPostingList',
        langLevels: '/languageLevels',
        diplomas: '/educationLevels',
        educLevel: '/educationLevel',
        preDefLang: '/PredefinedLanguages',
        FilterLangs: '/languages',
        jobTypes: '/jobtypes',
        checkCandidateCandidatures: '/api/Candidature/checkCandidature',
    },
    mission: {
        allMissions: '/api/mission/allMissions',
        listUninteresting: '/api/mission/uninterestingMissions',
        missionById: '/api/mission/',
        addViews: '/api/mission/show/',
        searchLocations: '/locations/search',
    },
    favorite: {
        listFavorite: '/api/mission/favoriteMissions',
        unfavorite: '/api/mission/unfavorite/',
        handleFavourites: '/api/Preference/new',
    },
    search: {
        savedSearch: '/api/saved-search',
        listSavedSearch: '/api/saved-search/list',
        savingSearch: '/api/saved-search/new',
        elasticSaveSearchQuery: '/api/saved-search/elastic/new',
    },
    candidature: {
        allCandidature: '/api/Candidature/candidatureList',
        proposedCandidate: '/api/mission/proposedMissions',
        cancelCandidature: '/api/Candidature/',
        applyCandidature: '/api/Candidature/new',
        setCandidatureStatus: '/api/Profil/mulitiposting/views',
        applyJobOfferAuthenticatedUser: '/api/mission/missionId/apply',
        applyJobOfferAnonymousUser: '/mission/missionId/apply',
    },
    settings: {
        communicate: {
            listPreferences: '/api/configurationTYpe/',
            editPreferences: '/api/configurationTYpe/',
        },
        support: {
            listFaq: '/api/faq/list',
            topFaq: '/api/faq/faqTopSearch',
            sendMail: '/api/faq/sendMail',
        },
    },
    timesheet: {
        listTimesheet: '/api/timeSheet/',
        listAgencies: '/api/timeSheet/agencies',
        listCompanies: '/api/timeSheet/companies',
        postTimes: '/api/timeSheet/new',
        getHours: '/api/timeSheet/timeSheetByDay',
        editHours: '/api/timeSheet/',
        postCr: '/api/timeSheet/uploadCr',
        getTimesheetId: '/api/timeSheet/timeSheetByDay/',
        collaboratorList: '/candidates/list',
        validate: '/api/timeSheet/validate/',
        export: '/api/timeSheet/export',
        listMission: '/api/timeSheet/missions',
    },
    dashbord: {
        percentProfile: '/api/Profil/percentage/',
        statisticDashbord: '/api/candidate/dashbordStatistics/',
        deleteItemCandidacies: '/api/candidate/dashbordCandidatureItemDelete/',
        canceledItemCandidacies: '/api/candidate/markCandidatureItemCanceled/',
    },
    notification: {
        listNotification: '/api/notifications/',
        listNotificationClient: '/api/client/notifications/',
        oneNotification: '/api/notifications/',
    },
    myDocuments: {
        listMyDocuments: '/api/Profil/documents/',
        addNewDocument: '/api/Profil/uploadFile/',
        ficheInscrption: '/api/generate-pdf',
    },
    params: {
        listParmas: '/api/paramter/ParameterList',
    },
};

const API_AGENCY = {
    cvTheque: {
        agencyCandidates: '/api/Profil/candidates',
        //agencyCandidates: '/api/candidates/elastic/dynamic/search',
        candidatesElacticSearch: '/api/candidates/elastic/dynamic/search',
        listMission: '/api/mission/missions',
        getFloder: '/api/favorite/folders',
        newMission: '/api/mission/candidate/new',
        newLink: '/api/link/mission/new',
        newFavorisApi: '/api/folder/isFavorite',
        newFoldersApi: '/api/favorite/folder',
        interestApi: '/api/interest/new',
        archivage: '/api/archive/candidate',
        listTags: '/api/listing/tags',
        apiTags: '/api/tags/candidate/',
        deleteTags: '/api/delete/tags/candidate/',
        apiSuccursale: '/api/succursales',
        apiEmail: '/api/emails/consultant',
        apiActivity: '/api/activity/new',
        apiCommentEdit: '/api/comment/',
        apiCommentAdd: '/api/comment/candidate/',
        disableCandidat: '/api/disable/candidate/',
        apiUser: '/api/user/',
        editFavoris: '/api/candidate/favorites/edit',
        checkWeek: '/api/timeSheet/verify',
        shareCandidat: '/api/candidate/share/',
    },
    ads: {
        cretaeNewAd: '/api/mission/new',
        listConsultings: '/api/consultants',
        platformSecursal: '/api/succursales',
        clientList: '/api/clients',
        listQualifications: '/qualifications',
        allClients: '/api/clients/list',
        duplicateCommandeClient: '/api/mission/commande/duplicate',
        imageSector: '/api/listing/activitySector/images/',
        professions: '/professions',
    },
    applications: {
        applicationsList: '/api/Candidature/company/candidature/list',
        interest: '/api/Candidature/change/interest',
        action: '/api/Candidature/change/status',
        details: '/api/Candidature/show/details',
    },
    presentationFolder: {
        createNewFolder: '/api/presentation/folder/new',
        listPresentationFolderCandidate: '/api/presentation/folders/',
        detailFolder: '/api/presentation/folder/',
        agencyDetail: '/api/agency/informations',
        delete: '/api/presentation/folder/delete',
    },
    file: {
        addNewFile: '/api/File/new',
    },
    filter: {
        workPermission: '/api/listing/work/permission',
        platformAndSuccursale: '/api/succursales',
        consultant: '/api/Candidature/company/consultant/list',
    },
    missions: {
        statistique: '/api/statistics/missions',
        statistiqueMissions: '/api/mission/statistics/missions/consultant',
        allMissions: '/api/mission/myMissions',
        updateMission: '/api/mission/',
        duplicateMission: '/api/mission/duplicate/',
        detailMission: '/api/mission/',
        pinnedMission: '/api/mission/mark/pinned/',
        detailAnnonce: '/offer/public/',
    },
    contact: {
        listContact: '/contacts',
    },
    myFolders: {
        listFolders: '/api/favorite/folder/',
        duplicateFolder: '/api/favorite/folder/copy/',
        deleteFolder: '/api/favorite/folder/delete/',
        editFolder: '/api/favorite/folder/edit/',
        dragFolder: '/api/favorite/folder/move',
        candidateList: '/candidates',
        candidateDetail: '/api/Profil/candidate/',
        deleteCandidateFromFolder: '/api/favorite/candidate/remove',
    },
    activity: {
        listActivity: '/api/activity/all',
        listType: '/activityTypes',
        listParticipant: '/api/participants',
        listMission: '/api/activity/missions',
        exportApi: '/api/export/activities',
        templatesApi: '/api/email/notif/templates',
        responseTemplates: '/api/email/notif/templates/user',
        apiTemplates: '/api/email/notif/template',
    },
    dashbord: {
        candidateApi: '/api/statistics/candidates',
        statsApi: '/api/statistics/stats',
        candidaturesApi: '/api/statistics/candidatures',
        multiposting: '/api/statistics/missions/multiposting',
        BaseCv: '/api/statistics/profils',
    },
    planning: {
        detailOrder: '/api/commande/',
        statsPlanning: '/api/global_planning/stats',
        markedOrders: '/api/global_planning/markedcommads',
        clientPlanning: '/api/global_planning/clients',
        globalPlanning: '/api/global_planning',
    },
    mailing: {
        sendApi: '/api/customemail/send',
    },
};

export { API_HOST, PATH_IMAGES_AGENCE, PATH_FILES_CANDIDATE, API, API_AGENCY };
